import { render, staticRenderFns } from "./AppMultipleItemsAnswer.vue?vue&type=template&id=7625fe4c&scoped=true"
import script from "./AppMultipleItemsAnswer.vue?vue&type=script&lang=ts"
export * from "./AppMultipleItemsAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppMultipleItemsAnswer.vue?vue&type=style&index=0&id=7625fe4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625fe4c",
  null
  
)

export default component.exports